module.exports = __webpack_public_path__ + "img/bg_cupra_tablet.5d2dc9bf.jpg";